export default "__VITE_ASSET__CyAGjfdT__"